///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.replenishment_request = abcsetup.replenishment_request || {};
abcsetup.replenishment_request.create = abcsetup.replenishment_request.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.replenishment_request.create = {
    init: function() {
        // $(function() {
        //     $( "#sortable" ).sortable({
        //         placeholder: "ui-state-highlight"
        //     });
        // });

        // Bind any fields events
        abcsetup.replenishment_request.common.bindFields();
    },


    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        abcsetup.replenishment_request.common.bindFormElems();
    },
}
